import React from 'react';
import { isMobile } from 'react-device-detect';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Box, Button, Typography } from '@mui/material';
import './assets/styles/font.scss';
import './assets/styles/application.scss';
import './lease_management/assets/styles/lease_management.scss';
import PrySideBar from '../src/shared_elements/components/layouts/PrySideBar';
import PryHeader from '../src/shared_elements/components/layouts/PryHeader';
import MobileHeader from './shared_elements/components/layouts/MobileHeader';
import AiChatLauncher from './shared_elements/components/layouts/AiChatLauncher';
import { useSelector } from "react-redux"; 
import { PageLoader, ChangePasswordPopUp } from './shared_elements';
import { PermissionWrapper } from './wrappers';
import NetworkStatusBanner from './shared_elements/components/NetworkStatusBanner';
import { getGlobalCookie } from './utils';
import config from './config'
// shown when a page crashes, mostly lazy page chunks that fail to download while offline
const PageErrorFallback = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, textAlign: 'center', minHeight: '60vh', px: 2 }}>
    <Typography variant="h6">{navigator.onLine ? "Couldn't load this page" : "You're offline"}</Typography>
    <Typography variant="body2" color="text.secondary">Check your internet connection and try again.</Typography>
    <Button variant="contained" onClick={() => window.location.reload()}>Retry</Button>
  </Box>
);

const App = () => {
  const isLoading = useSelector(state => state.leases.isLoading);
  const location = useLocation();

  const lessorAccess = getGlobalCookie('lessorAccess')
  let envCookie = null;
  try {
    envCookie = lessorAccess ? JSON.parse(lessorAccess)?.environment : null;
  } catch (e) {
    envCookie = null;
  }
  const env = config.env.key
  if (envCookie && env !== envCookie) {
    return window.location.href = `${config.domain.subDomian}login?apps=leaseRevamp`;
  }
  return (
    <>
        <PryHeader />
        <PrySideBar />
        <ErrorBoundary FallbackComponent={PageErrorFallback} resetKeys={[location.pathname]}>
          <Outlet />
        </ErrorBoundary>
        <NetworkStatusBanner />
        {isMobile ? <MobileHeader /> : null}
        {isLoading ? <PageLoader/> : null}
        <ChangePasswordPopUp />
        <PermissionWrapper
          extraProps={{
            application: "lease_revamp",
            feature: "ai_chat_bot",
            operationType: ["R"]
          }}
        >
          <AiChatLauncher />
        </PermissionWrapper>
    </>
  );
}
export default (App)
